// extracted by mini-css-extract-plugin
module.exports = {"card":"MoneyBackGuarantee_card__Hu2jS","image":"MoneyBackGuarantee_image__xIGl1"};